<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @export="exportFile"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-evg-purchase' }"
      :exportOptions="{
        params: { evgPurchaseCode: chooseTemplateOptions.evgPurchaseCode },
        checkUrl: '/ecom/evg/fty/purchase/exportCheck',
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import chooseTemplate from '@/views/ecom/components/choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, chooseTemplate },
  data() {
    return {
      usePage: true,
      chooseTemplateOptions: { visible: false, evgPurchaseCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomEvgPurchaseListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query }) {
      this.$router.push({
        name: 'ecom-evgBiz-evgPurchaseOrder-detail',
        params: { pageType, ...params },
        query,
      })
    },
    exportFile({ evgPurchaseCode }) {
      this.chooseTemplateOptions = { visible: true, evgPurchaseCode }
    },
  },
}
</script>
